var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('IconBtn',{attrs:{"title":"Add","icon":"mdi-plus"},on:{"click":_vm.create}}),_c('Table',{staticClass:"my-5"}),_c('Form'),_c('BizServiceLoad')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }